import client from "./sharedoClient";

const get = () => client.get("api/security/userInfo");

const getImage = userId => client.get(`/api/user/${userId}/profileImage/asBase64`)

export default {
    get,
    getImage
};